var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.transformed)?_c('router-link',{attrs:{"to":'/actions?type=attack&nickname='+_vm.dynamicTo}},[_vm._v(_vm._s(_vm.dynamicTo))]):_vm._e(),_c('div',[_vm._v(_vm._s(_vm.dynamicContent))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }